import { NotificationSegment } from '../../shared/services/notification/notification-list.store';

// #736 §11: /notifications?tab=unread|all.
//
// Der Parameter statt eines reinen Komponentenzustands, damit das Segment einen Reload und einen
// geteilten Link uebersteht: wer im Popover im Segment "Ungelesen" auf "mehr..." klickt, soll dort
// landen und nicht im vollen Bestand.
//
// Anders als PROFILE_TAB_QUERY_PARAM (#735) ist dieser Parameter KEIN Server-Vertrag —
// /notifications kommt in keiner der vom Server fest verdrahteten Routen vor. Der Erzeuger ist die
// eigene Glocke.

/** Der Name des Query-Parameters. */
export const NOTIFICATIONS_TAB_QUERY_PARAM = 'tab';

/**
 * Uebersetzt den Query-Parameter in ein Segment.
 *
 * Ausgewertet wird ausschliesslich der exakte Wert "all". Alles andere — ein anderer Name,
 * abweichende Gross-/Kleinschreibung oder ein fehlender Parameter — landet auf "unread". Ein
 * unbekannter Wert ist damit nie ein Fehlerfall.
 */
export function notificationSegmentFor(tab: string | null | undefined): NotificationSegment {
  return tab === 'all' ? 'all' : 'unread';
}
